/**
 * Custom Global Scripts for Graux
 */
(function () {
    'use strict';

    // Xmas Card Add to Cart Logic
    function initXmasCardAtc() {
        document.addEventListener('submit', function (e) {
            if (e.target && e.target.classList && e.target.classList.contains('amz-atc-form')) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                var form = e.target;
                var btn = form.querySelector('.amz-add-btn');
                var originalText = '';

                if (btn) {
                    originalText = btn.innerHTML;
                    btn.disabled = true;
                    btn.innerText = 'Adding...';
                }

                var formData = new FormData(form);

                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (response) {
                        if (response.status === 422) {
                            console.error('Error adding to cart', response);
                            if (btn) {
                                btn.innerText = 'Error';
                                setTimeout(function () {
                                    btn.disabled = false;
                                    btn.innerHTML = originalText;
                                }, 2000);
                            }
                            return;
                        }

                        if (window.openCartDrawer) {
                            window.openCartDrawer(true);
                        } else if (window.refreshCartDrawer) {
                            window.refreshCartDrawer().then(function () {
                                var drawer = document.getElementById('AjaxCartDrawer');
                                if (drawer) drawer.classList.add('drawer--is-open');
                                document.documentElement.classList.add('js-drawer-open', 'js-cart-drawer-open');
                            });
                        } else if (window.theme && window.theme.AjaxCart) {
                            window.theme.AjaxCart.open();
                        }

                        if (btn) {
                            btn.disabled = false;
                            btn.innerHTML = originalText;
                        }
                    })
                    .catch(function (error) {
                        console.error('Error:', error);
                        if (btn) {
                            btn.disabled = false;
                            btn.innerHTML = originalText;
                        }
                    });
            }
        }, true);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initXmasCardAtc);
    } else {
        initXmasCardAtc();
    }

})();
